import { Permission } from '../enums/permission';
import { Role } from '../enums/role';
import { Privileges } from '../types/privileges';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class PrivilegeService {
    public static canAccess(routePrivileges: Privileges | null, userRoles: Role[], userPermissions: Permission[]): boolean {
        if (this.routeHasNoPrivileges(routePrivileges)) {
            return true;
        }

        return (
            this.validateTargetPrivileges(routePrivileges?.roles || [], userRoles) ||
            this.validateTargetPrivileges(routePrivileges?.permissions || [], userPermissions)
        );
    }

    private static validateTargetPrivileges<T extends Role | Permission>(requiredPrivileges: T[], userPrivileges: T[]): boolean {
        return requiredPrivileges.some((privilege: T): boolean => userPrivileges.includes(privilege));
    }

    private static routeHasNoPrivileges(privileges: Privileges | null): boolean {
        if (!privileges) {
            return true;
        }

        return !privileges.roles.length && !privileges.permissions.length;
    }
}

export { PrivilegeService };
